import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    avatarCell: {
      width: '64px',
    },
    cell: {
      paddingBottom: theme.spacing(0.5),
      borderBottom: 'none',
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      '&:first-of-type': { paddingLeft: theme.spacing(2) },
      '&:last-of-type': { paddingRight: theme.spacing(2) },
    },
  };
};
